module.exports = __webpack_public_path__ + "img/airbel-logo-black-tagline.526f26a8.jpeg";